import { useSyncExternalStore } from "react";

export type T_DevicePlatform = "ios" | "android" | "desktop";

// Global cache to avoid re-computation across hook instances
let cachedPlatform: T_DevicePlatform | null = null;

function detectPlatform(): T_DevicePlatform {
  if (typeof navigator === "undefined") return "desktop";

  const ua = navigator.userAgent;

  // iOS detection - standard and modern iPads
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return "ios";
  }

  // Android detection
  if (/Android/i.test(ua)) return "android";

  return "desktop";
}

function getSnapshot(): T_DevicePlatform | null {
  if (cachedPlatform === null) {
    cachedPlatform = detectPlatform();
  }
  return cachedPlatform;
}

function getServerSnapshot(): T_DevicePlatform | null {
  return null;
}

// Value never changes after initial computation, so subscribe is a no-op
function subscribe(_callback: () => void): () => void {
  return () => {};
}

/**
 * Detects the current device platform.
 *
 * Returns `null` during SSR, then one of: "ios", "android", or "desktop".
 * Callers should handle the `null` case appropriately for their UI needs.
 */
export function useDevicePlatform(): T_DevicePlatform | null {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
